export default function AmmoLogo({ className = "w-10 h-10" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 110.35 66.09"
      className={className}
    >
      <defs>
        <linearGradient
          id="ammo-grad-1"
          x1="-4.84" y1="37.68" x2="71.5" y2="33.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="aqua" />
          <stop offset="1" stopColor="#339" />
        </linearGradient>
      </defs>
      <g>
        <path
          fill="url(#ammo-grad-1)"
          d="M67,33A10.34,10.34,0,1,0,77.33,22.7,10.35,10.35,0,0,0,67,33Z"
        />
        <path
          fill="url(#ammo-grad-1)"
          d="M66.24,1.91v0l-.12.05c-1.09.4-22,10.25-40,18.75l21.17,10C53.8,27.59,65,22.32,69.85,20a15,15,0,1,1,7.46,28,14.79,14.79,0,0,1-7.19-1.86l-2.28-1C65.35,44.1,39.71,32,21,23.14,9.31,28.63,0,33,0,33s64.18,30.4,66.13,31.11l.11,0v0a33,33,0,1,0,0-62.27Z"
        />
      </g>
    </svg>
  );
}
